// fetchBaseQuery passes `params` straight to `new URLSearchParams(...)`, which
// stringifies an `undefined` value as the literal string "undefined" instead
// of omitting the key. Strip undefined entries before they reach the query.
export function stripUndefinedParams<T extends Record<string, unknown>>(
  params: T,
): Partial<T> {
  const result: Partial<T> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) {
      (result as Record<string, unknown>)[key] = value;
    }
  }
  return result;
}
